import { Notification, NotificationProps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getPolicyToEndAt, isPolicyTerminated, Policy } from '../../../../../../domain'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../../../organisms/trans'

const tKey = TKey('pages.policy-configuration')

export interface PolicyCancellationNotificationProps extends NotificationProps {
  policy: Policy
}

export const PolicyCancellationNotification: FunctionComponent<
  PolicyCancellationNotificationProps
> = ({ policy, ...props }) => {
  const { t } = useWriskTranslation()

  if (isPolicyTerminated(policy)) {
    return (
      <Notification type='standalone' variant='info' {...props}>
        <Typo>
          <WriskTrans
            t={t}
            i18nKey={tKey('cancellation-message')}
            values={{
              endedAt: t(tFormats('datetime.medium'), {
                value: getPolicyToEndAt(policy),
              }),
            }}
          />
        </Typo>
      </Notification>
    )
  }

  return null
}
